export default __webpack_public_path__ + "static/media/Venturer's Bracers of the Untamed.a014b276.jpg";